export default __webpack_public_path__ + "static/media/crotchet.3d241b86.png";